// extracted by mini-css-extract-plugin
export var date = "screen1-module--date--80105";
export var postButton = "screen1-module--postButton--9b34a";
export var postTitle = "screen1-module--postTitle--432dc";
export var row = "screen1-module--row--5aa46";
export var screen1 = "screen1-module--screen1--78ad3";